import { render, staticRenderFns } from "./ReceivedByFNS-ColumnAlpha.vue?vue&type=template&id=3f7f8a20&"
import script from "./ReceivedByFNS-ColumnAlpha.vue?vue&type=script&lang=js&"
export * from "./ReceivedByFNS-ColumnAlpha.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedByFNS-ColumnAlpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports